/**
 * IB WEB MENUS
 */
angular.module('ib-web-menus-module', [
    'pascalprecht.translate',
    'LocalStorageModule',
    'ngCookies',
    'rx',
    'ib-main-header-module',
    'ib-main-footer-module',
    'ib-newMain-header-module',
    'ib-web-menus-constants-module',
    'ib-header-component-module',
    'ib-footer-component-module',
    'ib-header-advanced-search-module',
    'dependencies-shared-components-module',
    'ib-user-info-module'
]);
